

<ion-grid>
  <ion-row>
    <ion-col>
      <ion-card>
        <ion-card-header>
          <ion-card-title>
            <div class="header-with-button">
              Crafting Queue ({{ currentQueue.queue.length }} / {{ currentQueue.size }})

              <div [ngxTippy]="tooltip" *ngIf="queueUpgradeRequirements(currentQueue)">
                <ion-button color="primary" fill="outline" [disabled]="!canUpgradeQueue(currentQueue)" (click)="upgradeQueue(currentQueue)">Upgrade</ion-button>
              </div>

              <ng-template #tooltip>
                <div *ngIf="queueUpgradeRequirements(currentQueue) as upgradeRequirements">
                  <div><strong>Upgrade Cost</strong></div>
                  <br>
                  <div><strong>Coins</strong>: {{ upgradeRequirements.coins | number }}</div>
                  <div *ngFor="let resource of upgradeRequirements.resources | keyvalue">
                    <strong>{{ resource.key }}</strong>: {{ resource.value | number }}
                  </div>
                </div>
              </ng-template>
            </div>
          </ion-card-title>
        </ion-card-header>

        <ion-card-content class="crafting-queue-container">
          <ng-container>
            <div *ngIf="currentQueue.queue.length === 0">No items currently being crafted.</div>

            <div class="crafting-queue">
              <div class="crafting-queue-item"
                   [class.hovered]="visibleCancels[i]"
                   *ngFor="let craftItem of currentQueue.queue || []; let i = index; trackBy: trackBy"
                   [ngxTippy]="tooltip"
                   (mouseenter)="visibleCancels[i] = true"
                   (mouseleave)="visibleCancels[i] = false">

                <app-game-icon class="icon" [icon]="iconForRecipe(craftItem.recipe)"></app-game-icon>
                <ion-badge class="remaining" color="primary">{{ craftItem.totalLeft }}</ion-badge>
                <app-countdown class="timer" [duration]="craftItem.currentDuration + ((craftItem.totalLeft - 1) * craftItem.durationPer)"></app-countdown>

                <div class="cancel-container" *ngIf="visibleCancels[i]">
                  <ion-button class="cancel-warning"
                              color="warning"
                              fill="clear"
                              shape="round"
                              [analyticsClick]="'Refining:' + tradeskill + ':Cancel:' + craftItem.recipe.result"
                              (click)="cancel(i)">
                    <ion-icon name="close" slot="icon-only"></ion-icon>
                  </ion-button>
                </div>

                <ng-template #tooltip>
                  <app-item-tooltip *ngIf="itemOutputs[craftItem.recipe.result]" [item]="itemOutputs[craftItem.recipe.result]"></app-item-tooltip>
                  <app-resource-tooltip *ngIf="resourceOutputs[craftItem.recipe.result]" [resource]="resourceOutputs[craftItem.recipe.result]"></app-resource-tooltip>
                </ng-template>

              </div>
            </div>
          </ng-container>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col>
      <ion-card>
        <ion-card-content>
          <ion-row>
            <ion-col>
              <ion-item class="filter" lines="none" (click)="changeOption('hideDiscovered', !filterOptions.hideDiscovered)">
                <ion-checkbox slot="start" [checked]="!filterOptions.hideDiscovered"></ion-checkbox>
                <ion-label class="ion-text-wrap">Discovered</ion-label>
              </ion-item>
            </ion-col>

            <ion-col>
              <ion-item class="filter" lines="none" (click)="changeOption('hideHasIngredients', !filterOptions.hideHasIngredients)">
                <ion-checkbox slot="start" [checked]="!filterOptions.hideHasIngredients"></ion-checkbox>
                <ion-label class="ion-text-wrap">Creatable</ion-label>
              </ion-item>
            </ion-col>

            <ion-col>
              <ion-item class="filter" lines="none" (click)="changeOption('hideHasNoIngredients', !filterOptions.hideHasNoIngredients)">
                <ion-checkbox slot="start" [checked]="!filterOptions.hideHasNoIngredients"></ion-checkbox>
                <ion-label class="ion-text-wrap">Uncreatable</ion-label>
              </ion-item>
            </ion-col>

            <ion-col>
              <ion-item class="filter" lines="none" (click)="changeOption('hideDiscoveredTables', !filterOptions.hideDiscoveredTables)">
                <ion-checkbox slot="start" [checked]="!filterOptions.hideDiscoveredTables"></ion-checkbox>
                <ion-label class="ion-text-wrap">Discovered Crafting Tables</ion-label>
              </ion-item>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col>
      <ion-card>
        <ion-card-content>
          <ion-segment class="mb-1" [(ngModel)]="type">
            <ion-segment-button value="resources" [disabled]="resourceRecipes.length === 0" (click)="setType('resources')">
              Craftable Resources ({{ resourceRecipes.length }})
            </ion-segment-button>

            <ion-segment-button value="items" [disabled]="itemRecipes.length === 0"  (click)="setType('items')">
              Craftable Items ({{ itemRecipes.length }})
            </ion-segment-button>
          </ion-segment>

          <cdk-virtual-scroll-viewport class="scrollable-list" itemSize="105" minBufferPx="945" maxBufferPx="1575">
            <ion-list class="striped">
              <ion-item *cdkVirtualFor="let recipe of type === 'resources' ? resourceRecipes : itemRecipes; trackBy: trackBy"
                        (mouseenter)="visibleStars[recipe.result] = true" (mouseleave)="visibleStars[recipe.result] = false">
                <app-game-icon slot="start" [icon]="iconForRecipe(recipe)" [shimmer]="!discoveries[recipe.result]"></app-game-icon>

                <ion-label class="label">
                  <h2>
                    <strong class="recipe-name">
                      <span [ngxTippy]="tooltip" [ngClass]="[(rarityOutputs[recipe.result] || 'Common').toLowerCase()]">
                        <app-real-name [name]="recipe.result"></app-real-name>
                      </span>

                      <ion-icon class="yield-icon" name="help-circle" [ngxTippy]="amountTooltip" *ngIf="recipe.perCraft.max > 1"></ion-icon>

                      <ng-template #amountTooltip>
                        <span *ngIf="recipe.perCraft.min === recipe.perCraft.max">
                          Yields {{ recipe.perCraft.min }} per craft
                        </span>

                        <span *ngIf="recipe.perCraft.min !== recipe.perCraft.max">
                          Yields {{ recipe.perCraft.min }} - {{ recipe.perCraft.max }} per craft
                        </span>
                      </ng-template>
                    </strong>

                    <div class="resource-notifier" *ngIf="type === 'resources'">
                      <small>You have {{ resources[recipe.result] || 0 | number }} of these.</small>
                    </div>

                    <ng-template #tooltip>
                      <app-item-tooltip *ngIf="type === 'items' && itemOutputs[recipe.result]" [item]="itemOutputs[recipe.result]"></app-item-tooltip>
                      <app-resource-tooltip *ngIf="type === 'resources' && resourceOutputs[recipe.result]" [resource]="resourceOutputs[recipe.result]"></app-resource-tooltip>
                    </ng-template>
                </h2>

                  <div class="resources">
                    <app-time-resource-icon [time]="recipe.craftTime * (amounts[recipe.result] || 1)"
                                            [inlineIconSize]="true"
                                            [emphasizeText]="false"></app-time-resource-icon>

                    <app-resource-icon *ngFor="let resource of ingredients[recipe.result]"
                                       [name]="resource.name"
                                       [quantity]="recipe.preserve?.includes(resource.name) ? resource.amount : resource.amount * (amounts[recipe.result] || 1)"
                                       [maxQuantity]="(summedResources[resource.name] || 0)"
                                       [maxIsNotImportant]="recipe.preserve?.includes(resource.name)"
                                       [showX]="true"
                                       [inlineIconSize]="true"
                                       [emphasizeText]="false"
                                       [angryColorWhenQuantityExceedsMax]="true"></app-resource-icon>

                    <app-item-icon *ngFor="let item of itemIngredients[recipe.result]"
                                   [name]="item.name"
                                   [quantity]="recipe.preserve?.includes(item.name) ? item.amount : item.amount * (amounts[recipe.result] || 1)"
                                   [maxQuantity]="(summedResources[item.name] || 0)"
                                   [maxIsNotImportant]="recipe.preserve?.includes(item.name)"
                                   [showX]="true"
                                   [inlineIconSize]="true"
                                   [emphasizeText]="false"
                                   [angryColorWhenQuantityExceedsMax]="true"></app-item-icon>
                  </div>


                  <ion-button class="favorite"
                              color="primary"
                              *ngIf="visibleStars[recipe.result] || allStarredRecipes[recipe.result]"
                              (click)="toggleFavorite(recipe, !allStarredRecipes[recipe.result])"
                              fill="clear"
                              size="small"
                              shape="round">

                    <ion-icon slot="icon-only"
                              [icon]="allStarredRecipes[recipe.result] ? 'star' : 'star-outline'"></ion-icon>
                  </ion-button>
                </ion-label>

                <div slot="end">
                  <ion-grid>
                    <ion-row>
                      <ion-col class="craft-buttons">
                        <ion-button color="primary" fill="outline" (click)="modifyAmount(recipe, -1)" [disabled]="!amounts[recipe.result] || amounts[recipe.result] <= 1">
                          <ion-icon slot="icon-only" icon="remove"></ion-icon>
                        </ion-button>
                        <div class="amount">
                          <input class="editor" [(ngModel)]="amounts[recipe.result]" (change)="validateAmount(recipe.result, $event)" type="number" />
                        </div>
                        <ion-button color="primary" fill="outline" (click)="modifyAmount(recipe, 1)">
                          <ion-icon slot="icon-only" icon="add"></ion-icon>
                        </ion-button>
                        <ion-button class="craft"
                                    fill="clear"
                                    (click)="craft(recipe, amounts[recipe.result] || 1)"
                                    [disabled]="isQueueFull(currentQueue) || !canCraftRecipes[recipe.result]"
                                    [class.no-skillups]="level >= recipe.level.max"
                                    [analyticsClick]="'Refining:' + tradeskill + ':Craft:' + recipe.result">
                                    Craft <span *ngIf="level < recipe.level.max">&nbsp;(+1 Lv)</span>
                        </ion-button>
                      </ion-col>
                    </ion-row>

                    <ion-row *ngIf="recipe.maxWorkers > 0 && refiningWorkers.hasWorkers">
                      <ion-col class="worker-buttons">
                        <ion-button color="secondary" fill="outline" (click)="unassignWorker(recipe)" [disabled]="(workersPerRecipe[recipe.result] || 0) <= 0"
                                    ngxTippy="Remove Worker"
                                    [analyticsClick]="'Refining:' + tradeskill + ':RemoveWorker:' + recipe.result">
                          <ion-icon slot="icon-only" icon="remove"></ion-icon>
                        </ion-button>
                        <div class="amount">{{ (workersPerRecipe[recipe.result] || 0) | number }}/{{ recipe.maxWorkers }}</div>
                        <ion-button color="secondary" fill="outline" (click)="assignWorker(recipe)" [disabled]="(workersPerRecipe[recipe.result] || 0) >= recipe.maxWorkers || !refiningWorkers.canAssignWorker"
                                    ngxTippy="Add Worker"
                                    [analyticsClick]="'Refining:' + tradeskill + ':AddWorker:' + recipe.result">
                          <ion-icon slot="icon-only" icon="add"></ion-icon>
                        </ion-button>
                      </ion-col>
                    </ion-row>
                  </ion-grid>
                </div>
              </ion-item>
            </ion-list>
          </cdk-virtual-scroll-viewport>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>
